import { type RenderConfig } from "@components/ValidatedField";
import { FileSelectionField } from "@features/files/file-selection-field";
import {
	type FileSelectionFieldProps,
	type FileV2,
} from "../../files/file-selection-field/file-selection-field.types";
import { OfferFilesTable } from "../offer-files-table";

export const OfferFileSelectionField = (props: FileSelectionFieldProps) => (
	<FileSelectionField {...props} tableComponent={OfferFilesTable} />
);

export const DefaultOfferFileSelectionField = (
	canUploadFiles: boolean,
	canDeleteFiles: boolean,
) => {
	const Component = ({ fieldName, fieldValue, updateField, onChange }: RenderConfig<FileV2>) => (
		<OfferFileSelectionField
			name={fieldName}
			selectedFile={fieldValue}
			setSelectedFile={updateField}
			onChange={onChange}
			canUploadFiles={canUploadFiles}
			canDeleteFiles={canDeleteFiles}
		/>
	);
	Component.DisplayName = "DefaultOfferFileSelectionField - Inner";
	return Component;
};

export type { FileV2 } from "../../files/file-selection-field/file-selection-field.types";
